import React, { useEffect, useState } from "react";
import { TVehicle } from "models/inventory/interfaces/vehicle.interface";
import { ScalableImage, Typography } from "design_system/src";
import { vehicleDetailData, VehicleDetailImage } from "models/inventory/interfaces/vehicle-detail.interfaces";
import { VehicleDetailImagesType } from "models/inventory/enums/vehicle-images.enums";
import { translateImageType } from "views/VehicleDetail/helpers/translations";
import styles from "./FeaturedPhotos.module.scss";
import PhotosMobile from "../Photos/PhotosMobile";

interface FeaturedPhotosProps {
  isMobile: boolean;
  vehicle?: TVehicle;
  vehicleDetails?: vehicleDetailData;
}

const FeaturedPhotos: React.FC<FeaturedPhotosProps> = ({ vehicle, vehicleDetails, isMobile }) => {
  const [photos, setPhotos] = useState<VehicleDetailImage[]>([]);
  const imageType = [
    VehicleDetailImagesType.frontLightsPhoto,
    VehicleDetailImagesType.exhaustPhoto,
    VehicleDetailImagesType.frontWheelPhoto,
    VehicleDetailImagesType.dashboardPhoto,
    VehicleDetailImagesType.trunkOrSeatOpenPhoto,
    VehicleDetailImagesType.rearSuspensionPhoto,
    VehicleDetailImagesType.rearLightPhoto,
    VehicleDetailImagesType.rearWheelPhoto,
  ];

  useEffect(() => {
    if (vehicle && vehicleDetails) {
      const data = vehicle?.isNewVehicle ? vehicleDetails?.images : vehicle?.detailsImages;
      setPhotos(data?.filter((img) => imageType.includes(img.imageType)) ?? []);
    }
  }, [vehicle, vehicleDetails]);

  const getPhotoWidth = (index: number) => {
    const isEven = index % 2 === 0;
    const isOverHalf = index >= 4;
    const factor = (isOverHalf && !isEven) || (!isOverHalf && isEven) ? 1 : 2;
    return `${factor * 100 / 6}%`;
  };

  return (
    <>
      {isMobile && <PhotosMobile photos={photos} showThumbsRow={false} />}
      {!isMobile && <div className="m_b_lg">
        <div className={styles.featuredPhotosContainer}>
          {photos.map((photo, index) => (
            <div
              key={photo._id}
              className={styles.photoWrapper}
              style={{ width: getPhotoWidth(index) }}
            >
              <div className={styles.photoContainer}>
                <ScalableImage
                  src={photo.url}
                  alt={photo.name}
                  desktopWidth={25}
                  mobileWidth={25}
                  className={styles.photo}
                />
                <div className={styles.photoOverlay}>
                  <Typography weight="600" scale="medium">
                    {translateImageType(photo.imageType)}
                  </Typography>
                </div>
              </div>
            </div>
          ))}
        </div>
        {photos.length > 0 && <Typography
          scale="xsmall"
          weight="400"
          className="text_left"
        >
          *Imágenes de referencia
        </Typography>}
      </div>}
    </>
  );
};

export default FeaturedPhotos;
